<template>
  <img id="logo" :src="logoSrc">
</template>

<script>
export default {
  name: 'Logo',
  props: {
    height: [String, Number],
    organisationId: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    logoSrc() {
        return Number(this.organisationId) === 306
          ? 'https://www.mtcheeseman.co.nz/wp-content/themes/cheese-2019/images/Mt-Cheesman-logo.png'
          : '/static/logo_48x120.png';
    }
  }
}
</script>

<style scoped>
#logo {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue